"use strict";
/**
 * @module Services.ControlClient
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Server response from a FILTER_SUBSCRIBE and FILTER_UNSUBSCRIBE request.
 */
var ClientFilterSubscribeResponse = /** @class */ (function () {
    /**
     * Create a new ClientFilterSubscribeRequest instance
     *
     * @param filter  the number of clients selected by the request
     * @param selector  any errors that occurred
     */
    function ClientFilterSubscribeResponse(selected, errors) {
        this.selected = selected;
        this.errors = errors;
    }
    /**
     * Check if the response indicates a success
     *
     * @return  `true` if there were no errors
     */
    ClientFilterSubscribeResponse.prototype.isSuccess = function () {
        return this.errors.length === 0;
    };
    return ClientFilterSubscribeResponse;
}());
exports.ClientFilterSubscribeResponse = ClientFilterSubscribeResponse;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/control-client/client-filter-subscribe-response.js
// module id = 1885
// module chunks = 1